
import DrawBase from "./DrawBase"
import EditRectangle from "./EditRectangle"
class DrawRectangle extends DrawBase {
    constructor(options) {
        super(options);
        this.options = options;
    }

    initKeyPositions() {
        var rectangle = this.getRectangle(this.positions);
        this.positions = [rectangle[0], rectangle[3]];
        this.plot.attrPlot = {
            edit_positions: this.positions.slice()
        }; //标绘标识
    }

    //左键
    leftClick(evt) {
        var $this = this;
        var position = this.getCatesian3FromPX(evt.position);
        if ($this.positions.length == 0) {
            $this.positions.push(position.clone());
        }
        $this.positions.push(position);
    }

    mouseMove(evt) {
        var $this = this;
        if ($this.positions.length < 2) return;
        var cartesian = $this.getCatesian3FromPX(evt.endPosition);
        if (!$this.Cesium.defined($this.plot)) {
            $this.plot = $this.createRectangle($this.positions);
            $this.entities.push($this.plot);
            $this.editHelp = new EditRectangle(this.options); //初始化编辑类
        }
        if ($this.plot) {
            $this.positions.pop();
            $this.positions.push(cartesian);
        }
    }

    // leftDoubleClick(evt) {
    //     this.destroy();
    //     var rectangle=this.getRectangle(this.positions);
    //     this.positions=[rectangle[0],rectangle[3]];
    //     super.leftDoubleClick();
    //     this.callback && this.callback(this.plot);
    // }

}


export default DrawRectangle